import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  SkuFormat,
} from "services/KnowfullyAdminClient";

type SelectSkuFormatMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectSkuFormatMultiple = ({
  onChange,
  value,
  variant,
  disabled,
}: SelectSkuFormatMultipleProps) => {
  const { skuService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const { data, isFetching } = useQuery(
    ["SkuFormats"],
    () =>
      skuService.getSkuFormats(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  const handleChangeMultiple = (_: any, values: SkuFormat[]) => {
    onChange(values.map((v) => v.id!));
  };

  const formats = data?.data ?? [];

  return (
    <Autocomplete
      multiple
      ChipProps={{ size: "small" }}
      options={formats}
      getOptionLabel={(option) => option.name ?? "?"}
      value={formats.filter((r) => value.includes(r.id!) ?? false)}
      onChange={handleChangeMultiple}
      loading={isFetching}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={t({ id: "skuFormatLabel" })}
        />
      )}
    />
  );
};

export default SelectSkuFormatMultiple;
